export enum AppInstance {
    Dev = 0,
    Review = 10,
    Test = 20,
    Staging = 30,
    Live = 40,
}


// WEBPACK FOOTER //
// ./src/shared/enums/app-instance.enum.ts